import { Component, Input } from '@angular/core';
import { ThreeDotsComponent } from '../three-dots/three-dots.component';

@Component({
    selector: 'pin-loading-spinner-with-text-message',
    templateUrl: './loading-spinner-with-text-message.component.html',
    imports: [ThreeDotsComponent]
})
export class LoadingSpinnerWithTextMessageComponent {
  @Input()
  message = '';

  @Input()
  customClassForMessage = '';

  @Input()
  customClassForDots = '';
}
